import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeartIcon as HeartOutline, ScaleIcon } from '@heroicons/react/24/outline';
import { HeartIcon as HeartSolid } from '@heroicons/react/24/solid';
import { useSelection } from '../context/SelectionContext';

const ProductActions = ({ product, productType, size = 'md' }) => {
  const { t } = useTranslation('model');
  const { isFavorite, isCompared, toggleFavorite, toggleComparison } = useSelection();
  const fav = isFavorite(productType, product.id);
  const cmp = isCompared(productType, product.id);

  const dims = size === 'lg' ? 'w-9 h-9' : size === 'sm' ? 'w-7 h-7' : 'w-8 h-8';
  const iconSize = size === 'lg' ? 'w-5 h-5' : size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';
  const base = 'flex items-center justify-center rounded-lg border transition-colors';

  const stop = (fn) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    fn();
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={stop(() => toggleComparison(productType, product))}
        aria-label={t('oferta.do_porownania')}
        aria-pressed={cmp}
        className={`${base} ${dims} ${
          cmp ? 'border-blue-300 bg-blue-50 text-blue-600' : 'border-gray-200 text-gray-400 hover:bg-gray-50'
        }`}
      >
        <ScaleIcon className={iconSize} />
      </button>
      <button
        type="button"
        onClick={stop(() => toggleFavorite(productType, product))}
        aria-label={t('oferta.do_obserwowanych')}
        aria-pressed={fav}
        className={`${base} ${dims} ${
          fav ? 'border-rose-300 bg-rose-50 text-rose-500' : 'border-gray-200 text-gray-400 hover:bg-gray-50'
        }`}
      >
        {fav ? <HeartSolid className={iconSize} /> : <HeartOutline className={iconSize} />}
      </button>
    </div>
  );
};

export default ProductActions;
